import cn from 'classnames';
import React, {FC} from 'react';

import {IWidgetsLayout} from 'entities/metadata';

import {DictionaryLayoutItem} from './dictionary-layout-item';

interface IWidgetLayoutRowProps {
    dictionaryLayout?: Array<IWidgetsLayout>;
}

export const DictionaryLayoutRow: FC<IWidgetLayoutRowProps> = ({dictionaryLayout}: IWidgetLayoutRowProps) => (
    <div className={cn('main-widget-page__widget-row', 'widget-directories')}>
        {dictionaryLayout?.map(dictionary => (
            <DictionaryLayoutItem
                dictionary={dictionary}
            />
        ))}
    </div>
);
